import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    DropdownMenu,
    DropdownToggle,
    Label,
    Row,
    Table,
    UncontrolledDropdown,
} from "reactstrap";
import axios from "axios";
import Alerts from "../../util/Alerts";
import BlkFormik from "../../util/BlkFormik";
import { Form } from "formik";
import { find_aseguradoras, find_companias, find_ram_grupos, find_ramos, find_ramos_ramgrp } from "../../api/CacheApi";
import { BlkCalendario } from "../../coms/BlkCalendario";
import ReactTable from "react-table";
import { on_select } from "./actions";
import { BlkField } from "../../coms/BlkField";
import { routes } from "../General";
import { has_role, pos } from "../../util/General";
import { Condiciones } from "./Condiciones";
import moment from "moment";
import "moment/locale/es";
import { NombreRamo } from "../../coms/BlkGenerales";
import { Asegurados } from "./Asegurados";
import { DocDigitales } from "./DocDigitales";
import { Facturacion } from "./Facturacion";
import { CondicionesVehi } from "./CondicionesVehi";
import { Detalles } from "./Detalles";
import { ComboCliente } from "../ComboCliente";
import { BlkCheckBox } from "../../coms/BlkCheckBox";
import icono_condiciones from "assets/img/icon/condiciones.png";
import icono_facturacion from "assets/img/icon/facturacion.png";
import icono_detalle from "assets/img/icon/detalles.png";
import icono_asegurados from "assets/img/icon/asegurados.png";
import icono_interaccion from "../../assets/img/icon/interaccion.png";
import logo_doc from "../../assets/img/icon/docs.png";
import prestadores from "../../assets/img/icon/icon_prestadores.svg";
import { Link } from "react-router-dom";
import { BeneficiosYellowCard } from "../../beneficios/BeneficiosComponents";

class Polizas extends Component {
    constructor() {
        super(...arguments);
        this.alert = React.createRef();
        this.form = React.createRef();
        this.state = {
            data: [],
            data1: [],
            ramos: [],
            ramosList: [],
            nombres: null,
            telfs: null,
            correos: null,
            asegs: [],
            agentes: [],
            companias: [],
            pages: -1,
            pages1: -1,
            page: 0,
            page1: 0,
            loading: false,
            loading1: false,
            cot: {},
            itemPoli: {},
            cdUbicacion: null,
            cdCotizacion: null,
            cdRamo: null,
            itemAdi: {},
            adicionales: [],
            modalCondiciones: false,
            busquedaAvanzada: false,
            modalCondicionesVehi: false,
            modalDocDigitales: false,
            modalDetallesVehi: false,
            modalAsegurados: false,
            modalFacturacion: false,
            modalDetalles: false,
            vida: false,
            selected: -1,
            query: this.itemQuery(),
        };
    }

    itemQuery() {
        let desde;
        let hasta;
        if (has_role(this.props.user, "ROLE_ADMIN") || has_role(this.props.user, "ROLE_BROKER")) {
            desde = "";
            hasta = "";
        } else {
            desde = new Date(new Date().getFullYear(), new Date().getMonth() - 15);
            hasta = new Date();
        }
        return {
            page: 0,
            pageSize: 10,
            poliza: "",
            ramo: 0,
            aseg: 0,
            comp: 0,
            desde: desde,
            hasta: hasta,
            sorted: null,
            cdCliente: this.props.user.cdCliente,
            inclEjecutivo: false,
            cdEjecutivoAdm: this.props.user.cdEjecutivoAdm || 0,
            cdEjecutivo: this.props.user.cdEjecutivo || 0,
            cdPool: this.props.user.cdPool,
        };
    }

    componentDidMount() {
        find_ramos().then(resp => {
            let ramos = resp;
            find_ram_grupos().then(resp => {
                let areas = resp;
                find_ramos_ramgrp().then(resp => {
                    let ramosTmp = [];
                    resp.forEach(r => {
                        let item = Object.assign({}, r); //clono el item
                        item.nmRamo = ramos.find(ramo => ramo.cdRamo === item.cdRamo).nmRamo;
                        item.nmArea = areas.find(area => area.cdRamGrupo === item.cdRamGrupo).nmRamGrupo;
                        item.nm = item.nmRamo;
                        ramosTmp.push(item);
                    });
                    this.setState({
                        ramosList: ramos,
                        ramos: ramosTmp.sort((a, b) => a.nmRamo.localeCompare(b.nmRamo)),
                    });
                });
            });
        });

        find_aseguradoras().then(resp => {
            this.setState({ asegs: resp });
        });
        find_companias().then(resp => {
            this.setState({ companias: resp });
        });
    }

    /**
     * funcion a ejecutarse cuando se da click en guardar desde el menu
     */
    onSubmit = (newValues, actions) => {
        this.setState(
            {
                query: { ...this.state.query, ...newValues, page: 0 },
                page: 0,
                selected: -1,
                selected2: -1,
            },
            () => this.fetchData({}, actions)
        );
    };

    fetchData = (query = {}, actions) => {
        if (has_role(this.props.user, "ROLE_ADMIN") || this.state.query.cdCliente) {
            let query2 = Object.assign({}, this.state.query);
            query2.sorted = query.sorted;
            if (query.page >= 0) {
                query2.page = query.page;
                // query2.page = 1;
            }

            if (query.pageSize >= 0) {
                query2.pageSize = query.pageSize;
            }

            if (query2.page !== this.state.query.page || query2.page === 0) {
                axios
                    .post(routes.api + "/polizas", query2)
                    .then(resp => {
                        resp.data.content.forEach(p => {
                            switch (p.tipoPol) {
                                case "N":
                                    p.tipoPol = "POLIZA NUEVA";
                                    break;
                                case "R":
                                    p.tipoPol = "RENOVACIÓN";
                                    break;
                                default:
                                    break;
                            }
                        });

                        this.setState({
                            data: resp.data.content,
                            pages: resp.data.totalPages,
                            loading: false,
                            sorted: resp.data.sorted,
                            data1: [],
                            adicionales: [],
                            query: query2,
                        });
                        if (actions.setSubmitting) {
                            actions.setSubmitting(false);
                        }
                        resp.data.content?.length > 0 &&
                            document.getElementById("poliza").scrollIntoView({ behavior: "smooth" });
                    })
                    .catch(error => {
                        this.alert.current.handle_error(error);
                        if (actions.setSubmitting) {
                            actions.setSubmitting(false);
                        }
                    });
            }
        }
    };

    getEjecutivo = coti => {
        axios
            .get(routes.api + "/ejecutivoAdm", {
                params: {
                    cdEjecutivo: coti.cdEjecutivo,
                    cdCompania: coti.cdCompania,
                },
            })
            .then(resp => {
                this.setState({ nombres: resp.data.nombres, correos: resp.data.correos, telfs: resp.data.telefonos });
            });
    };

    onSelectAdicional = coti => {
        let ramo = this.state.ramos.find(ram => ram.cdRamo === coti.cdRamo);
        if (ramo && (ramo.nmRamo.includes("VIDA") || ramo.nmRamo.includes("MEDICA"))) {
            axios
                .get(routes.api + "/ubicacion", {
                    params: {
                        cdCompania: coti.cdCompania,
                        cdRamoCotizacion: coti.cdRamoCotizacion,
                    },
                })
                .then(resp => {
                    this.setState({
                        adicionales: resp.data,
                        itemPoli: coti,
                        vida: true, //para saber q mostrar en condiciones, asegurados y facturacion
                    });
                    document.getElementById("dummy").scrollIntoView({ behavior: "smooth" });
                })
                .catch(error => {
                    this.alert.current.handle_error(error);
                });
        } else {
            let query = {
                cdCliente: coti.cotizacion.cdCliente,
                poliza: coti.poliza,
                cdRamo: coti.cdRamo,
                cdAseguradora: coti.cotizacion.cdCotizacion, //con esto busca la aseguradora
                cdCompania: coti.cdCompania,
                page: 0,
                pageSize: 20,
                sorted: [],
                fcDesde: new Date(coti.fcDesde),
                fcHasta: new Date(coti.fcHasta),
            };

            let query2 = Object.assign({}, query);
            query2.sorted = query.sorted;
            if (query.page >= 0) {
                query2.page = query.page;
            }
            if (query.pageSize >= 0) {
                query2.pageSize = query.pageSize;
            }

            if (query2.page !== this.state.query.page || query2.page === 0) {
                axios
                    .post(routes.api + "/v-polizas", query2)
                    .then(resp => {
                        resp.data.content.forEach(p => {
                            if (p.tipo.indexOf("RENO") >= 0) {
                                p.tipo = "RENOVACIÓN";
                            }

                            if (p.tipo.indexOf("COTI") >= 0) {
                                p.tipo = "POLIZA NUEVA";
                            }
                        });

                        this.setState({
                            itemPoli: coti,
                            data1: resp.data.content,
                            pages1: resp.data.totalPages,
                            loading1: false,
                            vida: false, //para saber q mostrar en condiciones, detalles y facturacion
                        });
                        document.getElementById("dummy").scrollIntoView({ behavior: "smooth" });
                    })
                    .catch(error => {
                        this.alert.current.handle_error(error);
                    });
            }
        }
    };

    onSelectAnexo = coti => {
        this.setState({ itemAdi: coti });
    };

    showCondiciones = open => {
        this.setState({ modalCondiciones: open });
    };

    showBusquedaAvanzada = open => {
        this.setState({ busquedaAvanzada: open });
    };

    showDetallesVehi = open => {
        this.setState({ modalDetallesVehi: open });
    };

    showCondicionesVehi = open => {
        this.setState({ modalCondicionesVehi: open });
    };
    showDocDigitales = open => {
        this.setState({ modalDocDigitales: open });
    };

    showAsegurados = open => {
        this.setState({ modalAsegurados: open });
    };

    showFacturacion = open => {
        this.setState({ modalFacturacion: open });
    };

    isVam = r => {
        let ls_nm_grp_ramo = r.nmArea;
        return pos(ls_nm_grp_ramo, "MEDICA") > 0 || pos(ls_nm_grp_ramo, "VIDA") > 0;
    };

    handleResetForm = resetForm => {
        resetForm();
        this.setState({ ...this.state, query: this.itemQuery(), data: [], data1: [], selected: -1 });
    };

    render() {
        return (
            <div className="content">
                <Alerts ref={this.alert} />
                <Card>
                    <CardBody>
                        <CardTitle tag="h4">Pólizas</CardTitle>
                        <div className="container-fluid container-md">
                            <BlkFormik
                                initialValues={this.state.query}
                                onSubmit={this.onSubmit}
                                ref={this.form}
                                enableReinitialize={true}
                                validateOnChange={false}
                            >
                                {({ isSubmitting, resetForm, submitForm, setFieldValue, values }) => (
                                    <Form className="container">
                                        <Row>
                                            {(has_role(this.props.user, "ROLE_ADMIN") ||
                                                has_role(this.props.user, "ROLE_BROKER")) && (
                                                <div className="form-group col-lg-6">
                                                    <ComboCliente
                                                        setFieldValue={setFieldValue}
                                                        name={"cdCliente"}
                                                        alert={this.alert}
                                                        values={values}
                                                        typePerson={0}
                                                    />
                                                </div>
                                            )}
                                            {has_role(this.props.user, "ROLE_EJECUTIVO") && (
                                                <Col xs={2} className={"d-flex mt-4 align-items-center"}>
                                                    <Label className={"mr-2"}>Ejecutivo</Label>
                                                    <BlkField
                                                        component={BlkCheckBox}
                                                        styleInput={{ marginLeft: 0, marginTop: "-10px" }}
                                                        name={"inclEjecutivo"}
                                                    />
                                                </Col>
                                            )}
                                            {(has_role(this.props.user, "ROLE_ADMIN") ||
                                                has_role(this.props.user, "ROLE_BROKER")) &&
                                                !this.state.busquedaAvanzada && (
                                                    <div className="form-group col-lg-6">
                                                        <div className="m-1">
                                                            <Button
                                                                type={"submit"}
                                                                className="my-xl-4 btn__yellow"
                                                                onClick={() => {
                                                                    submitForm();
                                                                    document
                                                                        .getElementById("siniestroVam")
                                                                        ?.scrollIntoView({ behavior: "smooth" });
                                                                }}
                                                            >
                                                                Buscar
                                                            </Button>
                                                            {values.cdCliente && (
                                                                <Link
                                                                    to={`/perfil/${values.cdCliente}?icon=true`}
                                                                    type="button"
                                                                    className="btn btn-outline-primary m-1"
                                                                >
                                                                    <span>Consultar Cliente</span>
                                                                </Link>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                        </Row>
                                        <Row>
                                            <div className="form-group col-lg-6">
                                                <Button
                                                    className="btn my-md-4 btn__celeste-claro"
                                                    onClick={() => {
                                                        this.showBusquedaAvanzada(!this.state.busquedaAvanzada);
                                                    }}
                                                >
                                                    Búsqueda Avanzada
                                                </Button>
                                            </div>
                                        </Row>
                                        {this.state.busquedaAvanzada && (
                                            <>
                                                <Row>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Póliza: </Label>
                                                        <BlkField
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Póliza"
                                                            name="poliza"
                                                        />
                                                    </div>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Ramo: </Label>
                                                        <BlkField
                                                            component="select"
                                                            className="form-control w-100 inputTable"
                                                            name="ramo"
                                                        >
                                                            <option value="0">--TODOS--</option>
                                                            {this.state.ramos.map(ramo => (
                                                                <option key={ramo.cdRamo} value={ramo.cdRamo}>
                                                                    {ramo.nmRamo}
                                                                </option>
                                                            ))}
                                                        </BlkField>
                                                    </div>
                                                </Row>
                                                <div className="row">
                                                    <div className="form-group col-lg-6 m-0">
                                                        <small className="m-0 text-primary">Fecha Vigencia</small>
                                                    </div>
                                                </div>
                                                <Row>
                                                    <Col xs={12} sm={6}>
                                                        <Row>
                                                            <div className="form-group col-lg-6">
                                                                <Label>Desde: </Label>
                                                                <BlkField
                                                                    name="desde"
                                                                    placeholder="Ingrese Fecha"
                                                                    component={BlkCalendario}
                                                                />
                                                            </div>
                                                            <div className="form-group col-lg-6">
                                                                <Label>Hasta: </Label>
                                                                <BlkField
                                                                    name="hasta"
                                                                    placeholder="Ingrese Fecha"
                                                                    component={BlkCalendario}
                                                                />
                                                            </div>
                                                        </Row>
                                                    </Col>
                                                    <div className="form-group col-lg-6">
                                                        <Label>Aseguradora: </Label>
                                                        <BlkField
                                                            component="select"
                                                            className="form-control w-100 inputTable"
                                                            name="aseg"
                                                        >
                                                            <option value="0">--TODOS--</option>
                                                            {this.state.asegs.map(aseg => (
                                                                <option
                                                                    key={aseg.cdAseguradora}
                                                                    value={aseg.cdAseguradora}
                                                                >
                                                                    {aseg.nmAlias}
                                                                </option>
                                                            ))}
                                                        </BlkField>
                                                    </div>
                                                </Row>
                                                <Row>
                                                    <div className="form-group col-lg-6">
                                                        <br />
                                                        <Button
                                                            type={"submit"}
                                                            className="mb-3 mr-2 btn__yellow"
                                                            onClick={() => {
                                                                submitForm();
                                                                document
                                                                    .getElementById("siniestroVam")
                                                                    ?.scrollIntoView({ behavior: "smooth" });
                                                            }}
                                                            disabled={isSubmitting}
                                                        >
                                                            Buscar
                                                        </Button>
                                                        <Button
                                                            className="mb-3 btn__celeste-claro"
                                                            onClick={() =>
                                                                this.handleResetForm(resetForm, setFieldValue)
                                                            }
                                                        >
                                                            Nueva Consulta
                                                        </Button>
                                                    </div>
                                                </Row>
                                            </>
                                        )}
                                    </Form>
                                )}
                            </BlkFormik>
                            <br />
                            {this.state.nombres && (
                                <div className={"container"}>
                                    <small className="fs12 d-flex d-sm-block flex-column">
                                        <span className="text-primary option">Ejec. Cuenta:</span>
                                        <span className="text-verde option mx-1">{this.state.nombres} </span>
                                        <span>
                                            <span className="text-primary option fa fa-envelope" />
                                            <a
                                                href={"mailto:" + this.state.correos}
                                                className={"text-decoration-underline mx-1"}
                                            >
                                                {this.state.correos}
                                            </a>
                                        </span>
                                        <span>
                                            <span className="text-primary option fa fa-phone" />
                                            <a
                                                href={"tel:" + this.state.telfs}
                                                className={"text-decoration-underline mx-1"}
                                            >
                                                {this.state.telfs}
                                            </a>
                                        </span>
                                    </small>
                                </div>
                            )}
                            <br />
                            <Label>Pólizas: </Label>
                            <div id={"poliza"} />
                            <Row>
                                <Col xs={12}>
                                    <ReactTable
                                        noDataText={"No se ha encontrado información"}
                                        previousText={"Anterior"}
                                        nextText={"Siguiente"}
                                        pageText={"Página"}
                                        rowsText={"filas"}
                                        ofText={"de"}
                                        columns={[
                                            {
                                                Header: "Aseguradora",
                                                minResizeWidth: 50,
                                                width: 140,
                                                sortable: false,
                                                accessor: "cotizacion.aseguradora.nmAlias",
                                            },
                                            {
                                                Header: "Ramo",
                                                minResizeWidth: 50,
                                                width: 300,
                                                sortable: false,
                                                accessor: "cdRamo",
                                                Cell: row => (
                                                    <NombreRamo
                                                        cod={row.original.cdRamo}
                                                        list={this.state.ramosList}
                                                        className="check-center"
                                                    />
                                                ),
                                            },
                                            {
                                                id: "fcDesde",
                                                sortable: false,
                                                Header: "Fc Desde",
                                                accessor: d => {
                                                    return moment(d.fcDesde)
                                                        .locale("moment/locale/es")
                                                        .local()
                                                        .format("DD/MM/YYYY");
                                                },
                                                minResizeWidth: 10,
                                                width: 120,
                                            },
                                            {
                                                id: "fcHasta",
                                                sortable: false,
                                                Header: "Fc Hasta",
                                                accessor: d => {
                                                    return moment(d.fcHasta)
                                                        .locale("moment/locale/es")
                                                        .local()
                                                        .format("DD/MM/YYYY");
                                                },
                                                minResizeWidth: 10,
                                                width: 120,
                                            },
                                            {
                                                Header: "Póliza",
                                                sortable: false,
                                                minResizeWidth: 10,
                                                accessor: "poliza",
                                                width: 160,
                                            },
                                            {
                                                Header: "Tipo Póliza",
                                                sortable: false,
                                                minResizeWidth: 10,
                                                accessor: "cotizacion.tipo",
                                            },
                                        ]}
                                        getTdProps={(state, rowInfo) => {
                                            if (rowInfo && rowInfo.row) {
                                                return {
                                                    onClick: (e, handleOriginal) => {
                                                        this.setState({ adicionales: [], data1: [] });
                                                        this.onSelectAdicional(rowInfo.original);
                                                        this.getEjecutivo(rowInfo.original);

                                                        this.setState({
                                                            selected: rowInfo.index,
                                                            selected2: -1,
                                                        });
                                                        if (handleOriginal) {
                                                            handleOriginal();
                                                        }
                                                    },
                                                    style: {
                                                        cursor: "pointer",
                                                        //backgroundColor: rowInfo.index === this.state.selected ? '#47b2a2' : 'white',
                                                        color:
                                                            rowInfo.index === this.state.selected ? "white" : "black",
                                                        height: 35,
                                                    },
                                                    className:
                                                        rowInfo.index === this.state.selected ? "bg-primary" : "white",
                                                };
                                            } else {
                                                return {};
                                            }
                                        }}
                                        manual
                                        data={this.state.data}
                                        pages={this.state.pages}
                                        loading={this.state.loading}
                                        onFetchData={this.fetchData}
                                        defaultPageSize={10}
                                        className="-striped -highlight"
                                        page={this.state.page}
                                        pageSize={this.state.pageSize}
                                        onPageChange={page => this.setState({ page, selected: false })}
                                        onPageSizeChange={(pageSize, page) => this.setState({ page, pageSize })}
                                    ></ReactTable>
                                </Col>
                            </Row>
                            <br />
                            <div id={"dummy"} />
                            <br />
                            {this.state.adicionales.length > 0 ? (
                                <>
                                    <h4 className={"card-title"}>{"Pólizas - Anexos"}</h4>
                                    <div className={"container"}>
                                        <div className={"table-responsive py-0"}>
                                            <Table className="adjusttd text-center detallex table-striped mb-4">
                                                <thead className="text-primary">
                                                    <tr>
                                                        <th className="pt-3">Información Adicional</th>
                                                        <th className="pt-3">Item</th>
                                                        <th className="pt-3">Grupo</th>
                                                        <th className="pt-3">Prima ($)</th>
                                                        <th className="pt-3">Plan Cobertura</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.adicionales.map(adicional => (
                                                        <tr key={adicional.cdRubro}>
                                                            <td className="st-120 td-actions-primary">
                                                                <div className="text-center">
                                                                    <UncontrolledDropdown className={"info-adicional"}>
                                                                        <DropdownToggle
                                                                            tag="button"
                                                                            type="button"
                                                                            className="btn text-white w-100"
                                                                            caret
                                                                        >
                                                                            <img
                                                                                src={icono_interaccion}
                                                                                className={"p-1 st-20"}
                                                                            />
                                                                        </DropdownToggle>

                                                                        <DropdownMenu className={"py-0"}>
                                                                            <div>
                                                                                <div
                                                                                    className="text-primary option px-2 dropdown-item"
                                                                                    title="Ver condiciones"
                                                                                    onClick={() => {
                                                                                        this.onSelectAnexo(adicional);
                                                                                        this.showCondiciones(true);
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={icono_condiciones}
                                                                                        className="m-1 st-25"
                                                                                    />
                                                                                    <span>Condiciones</span>
                                                                                </div>
                                                                                <div className="dropdown-divider m-0" />
                                                                                <div
                                                                                    className="text-primary option px-2 dropdown-item"
                                                                                    title="Ver asegurados"
                                                                                    onClick={() => {
                                                                                        this.onSelectAnexo(adicional);
                                                                                        this.showAsegurados(true);
                                                                                    }}
                                                                                >
                                                                                    <img
                                                                                        src={icono_asegurados}
                                                                                        className="m-1 st-25"
                                                                                    />
                                                                                    <span>Asegurados</span>
                                                                                </div>

                                                                                <div className="dropdown-divider m-0" />

                                                                                <div className="text-left">
                                                                                    <div
                                                                                        className="text-primary option px-2 dropdown-item"
                                                                                        title="Ver facturas"
                                                                                        onClick={() => {
                                                                                            this.onSelectAnexo(
                                                                                                adicional
                                                                                            );
                                                                                            this.showFacturacion(true);
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={icono_facturacion}
                                                                                            className=" m-1 st-25"
                                                                                        />
                                                                                        <span>Facturación</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </DropdownMenu>
                                                                    </UncontrolledDropdown>
                                                                </div>
                                                            </td>
                                                            <td className="st-120">{adicional.item}</td>
                                                            <td className="st-120">{adicional.dscUbicacion}</td>
                                                            <td className="st-120">{adicional.totPriActual}</td>
                                                            <td className="st-140">{adicional.plan.dscPlan}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                </>
                            ) : null}

                            {this.state.data1.length > 0 ? (
                                <>
                                    <h4 className={"card-title"}>{"Pólizas - Anexos"}</h4>
                                    <div className={"container"}>
                                        <div className={"table-responsive py-0"}>
                                            <Table className="adjusttd text-center detallex table-striped mb-4">
                                                <thead className="text-primary">
                                                    <tr>
                                                        <th className="pt-3 st-120">Información Adicional</th>
                                                        <th className="pt-3 st-120">Aseguradora</th>
                                                        <th className="pt-3">Ramo</th>
                                                        <th className="pt-3 st-120">Fc Desde</th>
                                                        <th className="pt-3 st-120">Fc Hasta</th>
                                                        <th className="pt-3 st-120">Póliza</th>
                                                        <th className="pt-3 st-120">Tipo Movimiento</th>
                                                        <th className="pt-3 st-120">Factura</th>
                                                        <th className="pt-3 st-120">Anexo</th>
                                                        <th className="pt-3 st-120">Aplicación</th>
                                                        <th className="pt-3 st-120">Val. Asegurado</th>
                                                        <th className="pt-3 st-120">Prima Neta</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.data1.map(adicional => (
                                                        <tr key={adicional.cdRamoCotizacion}>
                                                            <td className="st-140 td-actions-primary">
                                                                <div className="text-center">
                                                                    <InfoAdicional
                                                                        coti={adicional}
                                                                        user={this.props.user}
                                                                        onSelectAnexo={this.onSelectAnexo}
                                                                        showCondiciones={this.showCondicionesVehi}
                                                                        showDetalles={this.showDetallesVehi}
                                                                        showDocDigitales={this.showDocDigitales}
                                                                        showFacturacion={this.showFacturacion}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>{adicional.aseguradora}</td>
                                                            <td>
                                                                <NombreRamo
                                                                    cod={adicional.cdRamo}
                                                                    className="check-center"
                                                                    list={this.state.ramosList}
                                                                />
                                                            </td>
                                                            <td>
                                                                {moment(adicional.fcDesde)
                                                                    .locale("moment/locale/es")
                                                                    .local()
                                                                    .format("DD/MM/YYYY")}
                                                            </td>
                                                            <td>
                                                                {moment(adicional.fcHasta)
                                                                    .locale("moment/locale/es")
                                                                    .local()
                                                                    .format("DD/MM/YYYY")}
                                                            </td>
                                                            <td>{adicional.poliza}</td>
                                                            <td>{adicional.tipo}</td>
                                                            <td>{adicional.factAseg}</td>
                                                            <td>{adicional.anexo}</td>
                                                            <td>{adicional.numAplica}</td>
                                                            <td>{adicional.totAsegurado}</td>
                                                            <td>{adicional.totPrima}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <br />
                                </>
                            ) : null}
                        </div>
                    </CardBody>
                </Card>

                <Condiciones
                    open={this.state.modalCondiciones}
                    item={this.state.itemAdi}
                    toggleModal={this.showCondiciones}
                    alert={this.alert.current}
                    poliza={this.state.itemPoli}
                    cdObjCotizacion={this.state.itemPoli.cdObjCotizacion}
                    ubicacion={this.state.cdUbicacion}
                    cotizacion={this.state.itemPoli.cdCotizacion}
                    ramo={this.state.cdRamo}
                    user={this.props.user}
                    vida={this.state.vida}
                    ramos={this.state.ramosList}
                />

                <CondicionesVehi
                    open={this.state.modalCondicionesVehi}
                    item={this.state.itemAdi}
                    toggleModal={this.showCondicionesVehi}
                    alert={this.alert.current}
                    poliza={this.state.itemPoli}
                    cdObjCotizacion={this.state.itemPoli.cdObjCotizacion}
                    ubicacion={this.state.cdUbicacion}
                    cotizacion={this.state.itemPoli.cdCotizacion}
                    ramo={this.state.cdRamo}
                    user={this.props.user}
                    vida={this.state.vida}
                    ramos={this.state.ramosList}
                />

                <Asegurados
                    open={this.state.modalAsegurados}
                    item={this.state.itemAdi}
                    toggleModal={this.showAsegurados}
                    alert={this.alert.current}
                    poliza={this.state.itemPoli}
                    cdObjCotizacion={this.state.itemPoli.cdObjCotizacion}
                    ubicacion={this.state.cdUbicacion}
                    user={this.props.user}
                    vida={this.state.vida}
                    ramos={this.state.ramosList}
                />

                {this.state.modalDetallesVehi && (
                    <Detalles
                        open={this.state.modalDetallesVehi}
                        item={this.state.itemAdi}
                        toggleModal={this.showDetallesVehi}
                        alert={this.alert.current}
                        poliza={this.state.itemPoli}
                        cdObjCotizacion={this.state.itemPoli.cdObjCotizacion}
                        ubicacion={this.state.cdUbicacion}
                        user={this.props.user}
                        vida={this.state.vida}
                        ramos={this.state.ramosList}
                    />
                )}

                <Facturacion
                    open={this.state.modalFacturacion}
                    item={this.state.itemAdi}
                    toggleModal={this.showFacturacion}
                    alert={this.alert.current}
                    poliza={this.state.itemPoli}
                    user={this.props.user}
                    vida={this.state.vida}
                    ramos={this.state.ramosList}
                />

                <DocDigitales
                    open={this.state.modalDocDigitales}
                    item={this.state.itemAdi}
                    toggleModal={this.showDocDigitales}
                    alert={this.alert.current}
                    poliza={this.state.itemPoli}
                    cotizacion={this.state.itemPoli.cdCotizacion}
                    ramo={this.state.cdRamo}
                    user={this.props.user}
                    vida={this.state.vida}
                    ramos={this.state.ramosList}
                />
                <BeneficiosYellowCard to={"/list/beneficios/gen"} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    auth: state.auth,
});

const mapDispatchToProps = {
    on_select,
};
export default connect(mapStateToProps, mapDispatchToProps)(Polizas);

export const InfoAdicional = ({
    coti,
    onSelectAnexo,
    showCondiciones,
    showDetalles,
    showFacturacion,
    showDocDigitales,
    user,
}) => {
    return (
        <UncontrolledDropdown className={"info-adicional"}>
            <DropdownToggle tag="button" type="button" className="btn text-white w-100" caret>
                <img src={icono_interaccion} className={"p-1 st-20"} />
            </DropdownToggle>
            <>
                <DropdownMenu>
                    <div
                        className="text-primary option px-2 dropdown-item"
                        title="Ver detalles"
                        onClick={() => {
                            onSelectAnexo(coti);
                            showDetalles(true);
                        }}
                    >
                        <img src={icono_detalle} className={"m-1 st-20"} />
                        <span>Detalles</span>
                    </div>

                    <div className="dropdown-divider m-0" />
                    <div
                        className="text-primary option px-2 dropdown-item"
                        title="Ver facturas"
                        onClick={() => {
                            onSelectAnexo(coti);
                            showFacturacion(true);
                        }}
                    >
                        <img src={icono_facturacion} className={"m-1 st-20"} />
                        <span>Facturación</span>
                    </div>
                    {(has_role(user, "ROLE_ADMIN") || has_role(user, "ROLE_BROKER")) && (
                        <div
                            className="text-primary option px-2 dropdown-item"
                            title="Ver DocDigitales"
                            onClick={() => {
                                onSelectAnexo(coti);
                                showDocDigitales(true);
                            }}
                        >
                            <img src={logo_doc} className={"m-1 st-20"} />
                            <span>Docs. Digitales</span>
                        </div>
                    )}
                </DropdownMenu>
            </>
        </UncontrolledDropdown>
    );
};
